import { ReactNode } from 'react';
import { cn } from '@/lib';

interface DashboardPageHeaderProps {
  title: string;
  description?: string;
  videoPlayer?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function DashboardPageHeader({
  title,
  description,
  videoPlayer,
  actions,
  className,
}: DashboardPageHeaderProps) {
  return (
    <>
      {/* Header */}
      <div
        className={cn(
          'my-4 flex flex-col items-center justify-between gap-4 md:flex-row md:gap-0',
          className,
        )}
      >
        <div className="flex flex-col gap-2">
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
            {videoPlayer}
          </div>
          {description && <p className="text-sm text-gray-700">{description}</p>}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {/* Divider */}
      <div className="bg-primary-100 my-4 h-px w-full" />
    </>
  );
}
